import { DefaultPresenter } from './default-presenter';

const prefix = 'tag';
const entity = 'Tag';

export const TagPresenter = {
	...DefaultPresenter({ prefix, entity })
};
